const t = "_wrapper_13q4t_1", r = "_inner-wrapper_13q4t_18", p = "_carouselWrapper_13q4t_21", e = "_list_13q4t_24", _ = "_topWrapper_13q4t_44", a = "_title_13q4t_49", s = "_text_13q4t_53", o = {
  wrapper: t,
  innerWrapper: r,
  carouselWrapper: p,
  list: e,
  topWrapper: _,
  title: a,
  text: s
};
export {
  p as carouselWrapper,
  o as default,
  r as innerWrapper,
  e as list,
  s as text,
  a as title,
  _ as topWrapper,
  t as wrapper
};
